const statusInfo = {
  '-1': '请关闭该账户下所有已开启的广告计划后再试。',
  '-2': '余额不足无法退款',
  '-3': '查询失败',
  '-4': '已经存在退款无法进行退款申请',
  '-5': '当前没有结算',
  '-6': '申请失败',
  '-7': '异常出错'
}

export function StatusInfo(status) {
  return statusInfo[status];
}



// WEBPACK FOOTER //
// ./src/api/retStatus.js